import {len}  from './helpers';

export default function (maxLength) {
    return function (value) {
        return value ? len(value) <= maxLength : true
    }
}
